module.exports = __webpack_public_path__ + "static/education-1fac52b57673b8c20bb11cd67bd49d98.jpg";